module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.svg";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module id = 342
// module chunks = 24 26